import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { I18nextProvider } from 'react-i18next';
import i18n, { initI18n } from './i18n';
import App from './app/App';

function Root() {
  const [i18nReady, setI18nReady] = useState(false);

  useEffect(() => {
    initI18n()
      .then(() => {
        console.log('[Root] i18n ready, rendering app');
        setI18nReady(true);
      })
      .catch((err: Error) => {
        console.error('[Root] i18n init failed:', err);
      });
  }, []);

  if (!i18nReady) {
    return <div style={{ padding: 20 }}>Loading translations...</div>;
  }

  return (
    <I18nextProvider i18n={i18n}>
      <App />
    </I18nextProvider>
  );
}

// Wacht tot Office JS is geladen voordat we de React app renderen
Office.onReady(() => {
  console.log('[Office] Office.js ready');

  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );

  root.render(
    <React.StrictMode>
      <Root />
    </React.StrictMode>
  );
});
